import { Box, Card } from 'roo-ui/components';
import { ContentHeading } from 'components/Typography';
import { FormattedCalendarDate } from 'components/Formatters';
import { GroupItems, Item, ItemGroup } from 'components/ReviewCard';
import CancellationPolicyMessageBoard from '../../CancellationPolicyMessageBoard';

const NewStayDates = ({ newCheckIn, newCheckOut, openCancellationPolicyModal, ...rest }) => (
  <Box {...rest}>
    <ContentHeading data-testid="change-date-quote-new-stay-dates-title" mb={2} fontSize={['xl', '2xl']}>
      New stay dates
    </ContentHeading>
    <CancellationPolicyMessageBoard onClickCancellationPolicy={openCancellationPolicyModal} />
    <Card p={0} mt={3}>
      <ItemGroup data-testid="change-date-quote-new-stay-dates">
        <GroupItems pt={0}>
          <Item data-testid="new-check-in-date" labelItem="Check-in" valueItem={<FormattedCalendarDate date={newCheckIn} />} boldValue />
          <Item data-testid="new-check-out-date" labelItem="Check-out" valueItem={<FormattedCalendarDate date={newCheckOut} />} boldValue />
        </GroupItems>
      </ItemGroup>
    </Card>
  </Box>
);

export default NewStayDates;
